var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"toggle-capsule-component",style:(`border-color: ${_vm.border_color ? _vm.border : _vm.color}`),on:{"click":function($event){return _vm.$emit('toggleClicked')}}},[_c('div',{staticClass:"toggle-capsule-component-fill",style:(`
      background-color: ${_vm.color};
      padding-right: ${_vm.is_active ? '30px' : '10px'};
    `)}),_c('div',{staticClass:"toggle-capsule-component-circle",style:(`
      border-color: ${_vm.border_color ? _vm.border : _vm.color};
      background-color: ${_vm.knob};
      margin-left: ${_vm.is_active ? '19px' : '-1px'};
    `)})])
}
var staticRenderFns = []

export { render, staticRenderFns }